"use client";
import { NavBar, Footer } from "../partials";
import { ScrollToTop, Story } from '@/components/elements';
import style from '@/assets/styling/scss/stories.module.scss';
import { useEffect, useState } from "react";
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0.2 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      when: "beforeChildren",
      duration: 0.4,
    },
  },
};

export default function SuccessStories() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    async function loadStories() {
      try {
        const response = await fetch('/data/stories.json');
        const data = await response.json();
        const storiesDataArray = Object.values(data);
        setStories(storiesDataArray);
      } catch (error) {
        console.error('Error loading stories:', error);
      }
    }
    loadStories();
  }, []);

  if (stories.length === 0) return null; // this line is neccessary to stagger <Story /> animation

  return (
    <>
      <ScrollToTop />
      <NavBar />
      <main style={{ maxWidth: '122rem', margin: '15rem auto', padding: '0' }}>
        <motion.section
          className={style.stories}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {stories.map(story => (
            <Story key={story.id} {...story} />
          ))}
        </motion.section>
      </main>
      <Footer />
    </>
  );
}
